import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@material-ui/core";

import useStyles, {
  aboutDrawerWidth,
} from "../Styles";

const ColoradoRiverAccessSidebarChart = ({ chart_data }) => {
  const classes = useStyles();

  let filteredData = chart_data.filter((data) => data?.y !== 0)
  Highcharts.setOptions({
    chart: {
        style: {
            fontFamily: 'Arial'
        }
    }
  });


  
  const options = {
    chart: {
      type: "pie",
      plotBackgroundColor: "transparent",
      backgroundColor: "transparent",
      width: aboutDrawerWidth - 20,
      marginBottom: 125,
      fontFamily: 'Arial'
    },
    title: {
      text: null,
    },
    
    series: [
      {
        name: "Cities Water Usage",
        data: filteredData,
      },
    ],
    credits: {
      enabled: false,
    },

    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          format: '{point.y}%',
          distance: -50,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4
          },
          style: {
            font: "normal normal normal 12px/14px Arial",
            letterSpacing: "0.72px",
            fontWeight: "normal",
            color: "#FFFFFF", // default color is white
            opacity: 1,
          },
        },
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            opacity: 1,
          },
        },
        borderWidth: 0,
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            legendItemClick: function () {
              return false; // <== returning false will cancel the default action
            },
          },
        },
      },
    },
    colors: ["#2352D0", "#6AA4DC", "#96D9E4", "#FFB607", "#DE3E40"],
    tooltip: {
      enabled: false,
    },
    legend: {
      itemStyle: {
        color: "#333333",
        fontSize: "12px",
        fontWeight: "normal",
        fontFamily: "Arial",
      },
      align: 'center',
      //   width: "25%",
      padding: 10,
      itemMarginTop: 5,
      itemMarginBottom: 5,
      reversed: true,
      symbolRadius: 0
    },
  };


  

  return (
    <Box className={classes.chartContainer}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};
export default ColoradoRiverAccessSidebarChart;
